export const environment = {
  production: true,
  API_BASE: '__API_BASE__',
  AUTH_BASE: '__AUTH_BASE__',
  SHOP_API_BASE: '__SHOP_API_BASE__',
  INTEGRATIONS_API_BASE: '__INTEGRATIONS_API_BASE__',
  DEBUG: false,
  GETSTREAM: {
    API_KEY: '__GETSTREAM_API_KEY__',
    APP_ID: '__GETSTREAM_APP_ID__'
  },
  RECAPTCHA_SITE_KEY: '__RECAPTCHA_SITE_KEY__',
  RECAPTCHA_V3_SITE_KEY: '6LcUr7wUAAAAAKDnl7wIQrWFwad52ipdSTzBRyG-',
  REFERRAL_BASE: '__REFERRAL_BASE__',
  REPORTING_BASE: '__REPORTING_BASE__',
  SERVICES_BASE: '__SERVICES_BASE__',
  SHOW_VERSION: '__SHOW_VERSION__',
  SOCIAL_NETWORKS: {
    GREENHOUSE_CLIENT_ID: '__GREENHOUSE_CLIENT_ID__',
    SMARTRECRUITERS_CLIENT_ID: '__SMARTRECRUITERS_CLIENT_ID__'
  },
  SHORTENER_BASE: '__SHORTENER_BASE__',
  CANDIDATE_BASE: '__CANDIDATE_BASE__',
  CONTENT_BASE: '__CONTENT_BASE__'
};
